import { StepType, useTour } from "@reactour/tour";
import DOMPurify from "dompurify";
import cx from "classnames"
import styles from "./tour.module.scss"
import _, { size } from "lodash";
import { components } from "@reactour/tour";
import { useEffect, type ComponentProps } from "react";
import Actions from "src/components/actionbar";
import Button from "src/components/button";
import { useTourAdoption } from "src/redux/actions/adoption/tour";
import { handleTourClose } from "src/utils/productTours";
import { MediaTypeEnum, TourStep } from "../tour.type";

type ArrowProps = ComponentProps<typeof components.Arrow>;


export default function RenderStep(props: TourStep) {
  const { setIsOpen, steps } = useTour();

  useEffect(() => {
    const bg = props.backgroundImage ? props.backgroundImage : "";

    const popover = document.querySelector(
      ".reactour__popover"
    ) as HTMLElement | null;

    if (!popover) return;

    if (bg) {
      popover.style.backgroundImage = `url(${bg})`;
      popover.style.backgroundSize = "contain";
      popover.style.backgroundPosition = "center";
      popover.style.backgroundRepeat = "no-repeat";
    } else {
      popover.style.backgroundImage = "";
    }
  }, [props]);


  return (
    <div id="tourContainer"
      className={cx(styles.tourContainer, {
        [styles.progressBarActive]:
          size(steps) > 1
      })}>
      {props.title && <p className={styles.title} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.title, { ADD_ATTR: ['target', 'rel'] }) }}></p>}
      {props.content && <p className={styles.content} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.content, { ADD_ATTR: ['target', 'rel'] }) }}></p>}
      {renderMedia(props)}
    </div>
  )
}

const renderMedia = ({ media }) => {
  if (_.isEmpty(media)) return null;
  if (media.type === MediaTypeEnum.Video) {
    return (
      <video className={styles.media} muted autoPlay loop>
        <source src={media.source} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    );
  }

  if (media.type === MediaTypeEnum.Image) {
    return <img src={media.source} alt="Tour Step Media" className={styles.media} />;
  }
}

export const parseStepsToComponents = (jsonSteps: any[]): StepType[] => {
  return jsonSteps.map(step => ({
    selector: step.selector,
    content: <RenderStep {...step} />
  }))
}

export const NavigationComponent = (props) => {

  const { currentStep, steps, setCurrentStep, setIsOpen, meta, setMeta, setSteps } = useTour();
  const currentStepObj = steps[currentStep];
  const stepData = _.get(currentStepObj, "content.props", {})

  const { trackTourEvent } = useTourAdoption();

  const handleCTAClick = () => {
    const { cta } = stepData;
    if (cta?.url) window.open(cta.url, "_blank", "noopener,noreferrer");
    if (cta?.event) trackTourEvent(cta.event);
  };

  const handleClose = () => {
    setCurrentStep(0);
    setSteps && setSteps([]);
    setIsOpen && setIsOpen(false);
    setMeta && setMeta("");
    handleTourClose(meta)
  }

  return (
    <div className={styles.navigationContainer}>
      <i className={cx("paperflite-close", styles.closeButton)} onClick={handleClose} />

      {size(steps) > 1 && <div className={styles.navigationDots}>
        <div className={styles.progressBars}>
          {steps.map((step, index) => (
            <div
              key={index}
              className={cx(styles.progressBar, {
                [styles.activeProgressBar]: index === currentStep,
              })}
            ></div>
          ))}
        </div>
      </div>}
      <div className={cx(styles.navigationButtons)}>
        {currentStep - 1 >= 0 && (
          <i className={cx("paperflite-left-arrow", styles.prevButton)} onClick={() => setCurrentStep((prev) => prev - 1)} />
        )}
        <div className={cx({
          [styles.prevButtonActive]: currentStep - 1 >= 0,
        }, styles.rightContainer)}>

          {currentStep + 1 < steps.length && (
            <Button
              variant="primary"
              icon="paperflite-right-arrow"
              className={cx(styles.rightArrow)}
              text="Next"
              onClick={() => setCurrentStep((prev) => prev + 1)}
              disabled={false}
            />)}


          {_.size(_.get(stepData, "cta.url", '')) > 0 && <Button
            variant="primary"
            icon="paperflite-right-arrow"
            className={cx(styles.rightArrow)}
            text={_.get(stepData, "cta.text", "Open link")}
            onClick={handleCTAClick}
            disabled={false}
          />}
        </div>

      </div>
    </div>

  )
}
